import { useNavigate } from 'react-router-dom';

import { NotFoundIcon } from './components/NotFoundIcon';
import Styles from './NotFound.module.scss';

import { Button } from '@/components/Elements/Button';

export const NotFoundLayout = () => {
	const navigate = useNavigate();
	return (
		<div className={Styles.container}>
			<NotFoundIcon className={Styles.icon} />
			<div className={Styles.title}>Page Not Found</div>
			<div className={Styles.message}>
				{`The page you are looking for does not exist. It might have been moved or deleted.`}
			</div>
			<Button className={Styles.button} onClick={() => navigate('/')}>
				Go to dashboard page
			</Button>
		</div>
	);
};
